<template>
<div class="yumui-alert-mask" v-show="visible">
	<div class="yum-alert amint">
		<div class="yum-header" v-html="title"></div>
		<div class="yum-body" v-html="content"></div>
		<div class="yum-footer">
			<button class="yum-button no" v-if="NoText" @click="no()">{{NoText}}</button>
			<button class="yum-button ok" @click="ok()">{{OkText}}</button>
		</div>
	</div>
</div>
</template>

<script>
	export default{
		name:"Alert",
		data(){
			return{
				title : '温馨提示',
				content:'3234',
				OkText : '确定',
				NoText : '取消',
				visible: false,
				clicked : (res)=>{}
			}
		},
		methods:{
			ok(){
				this.visible = false;
				this.clicked(true);
			},
			no(){
				this.visible = false;
				this.clicked(false);
			}
		}
	}
</script>

<style lang="css" scoped>
.amint{animation: bounce-in .2s;}
@keyframes bounce-in {
  0% {transform: scale(0);}
  100% {transform: scale(1);}
}

.yumui-alert-mask {
    min-height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background: rgba(0,0,0,.3);
}
.yumui-alert-mask>.yum-alert{
	border-radius: 10px;
	background-color: #fff;
    width: 85%;
    font-size: 16px;
}
.yumui-alert-mask>.yum-alert>.yum-header{
	text-align: center;
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 700;
    color: #333;
    padding:15px 0;
}
.yumui-alert-mask>.yum-alert>.yum-body{
	padding: 10px 20px 15px;
    border-bottom: 1px solid #ddd;
    min-height: 36px;
    text-align: center;
}
.yumui-alert-mask>.yum-alert>.yum-footer{
	display: flex;
    align-items: center;
    border-radius:10px;
}
.yumui-alert-mask>.yum-alert>.yum-footer>.yum-button{
	padding:12px 0;
	display: inline-block;
	text-align: center;
	font-size: 1em;
	background: #fff;
	border:none;
	flex: 1;
}
.yumui-alert-mask>.yum-alert>.yum-footer>.yum-button:first-child{
	border-right:1px solid #ddd;
	border-bottom-left-radius: 10px;
}

.yumui-alert-mask>.yum-alert>.yum-footer>.yum-button:focus{
	outline:0;
}

.yumui-alert-mask>.yum-alert>.yum-footer>.yum-button:last-child{
	border-bottom-right-radius: 10px;
}
.yumui-alert-mask>.yum-alert>.yum-footer>.yum-button.ok{
	color: #26a2ff;
}
</style>



// WEBPACK FOOTER //
// src/components/alert/alert.vue